import React from 'react';
import type { BranchUI } from '@/common/types/vip-vendor-contact-us.type';
import { Collapse } from 'antd';
import ExpandIcon from './expand-icon.component';
import SectionInfo from './section-info.component';
import SectionMap from './section-map.component';

export default function SectionPanel({ branch }: { branch: BranchUI }) {
  const { id, title, hasMap, mapCenter, mapPins } = branch;

  return (
    <Collapse
      key={id}
      defaultActiveKey={id}
      expandIconPosition="end"
      expandIcon={({ isActive }) => <ExpandIcon isActive={!!isActive} />}
      style={{ width: '100%' }}
      className="mt-7 flex flex-col justify-center gap-3 !overflow-visible overflow-y-auto border-0 bg-white"
      items={[
        {
          key: id,
          label: title,
          style: { border: '1px solid #DFDFDD' },
          className: '!rounded-t-[10px] bg-[#F2F1F1] font-medium',
          children: (
            <div className="flex h-fit min-h-fit w-full flex-col gap-4 overflow-hidden rounded-lg md:flex-row">
              <SectionInfo branch={branch} />
              {hasMap && (
                <SectionMap
                  id={`map-${id}`}
                  center={mapCenter}
                  pins={mapPins}
                />
              )}
            </div>
          ),
        },
      ]}
    />
  );
}
